(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('main-header', class extends baseComponent.default {
    elements = {
      nav: 'main-nav'
    };
    
    render() {
      this.on('stickyMainHeader', (e, { sticky }) => {
        if(sticky) {
          // Awesome Kiwi fix (layout shift): keep the header's space reserved when it becomes sticky.
          // The theme reserved only the desktop menu height, so on mobile the page jumped up ~115px when scrolling.
          // Measure the header before and after it turns sticky and pad the difference, so content never moves.
          const heightBefore = this.offsetHeight;
          document.body.style.setProperty('--sticky-header-offset', '0px');
          this.classList.add('@sticky');
          const heightAfter = this.offsetHeight;
          document.body.style.setProperty('--sticky-header-offset', `${Math.max(0, heightBefore - heightAfter)}px`);
        } else {
          this.classList.remove('@sticky');
          document.body.style.setProperty('--sticky-header-offset', '0px');
        }
      })
    };
  });
})();